import http_request from './http_request'
import config from 'config'

function saveExternalSlide(payload) {
	//When it's from google slides the payload contains:
	//slideExternalId, presentationExternalld, slideId, source
	return http_request.post(`${config.api}slide/external`)
		.send(payload)
}

function getExternalSlide(payload) {
	return http_request.get(`${config.api}slide/external`)
		.send(payload)
}

export default {
	saveExternalSlide,
	getExternalSlide,
}
